import type { CmpHider } from './types';

export const framer: CmpHider = {
  id: 'framer',
  label: 'Framer (built-in cookie banner)',
  css: `
      /* Framer's built-in cookie banner. Framer injects it at runtime via a
         "cookieBanner-..." script into a wrapper appended to <body>; that
         wrapper and its fixed positioning layers carry only inline styles (no
         id/class), but the banner card itself has the stable class
         "--framer-cookie-banner-container" and its buttons use ids like
         "#__framer-cookie-component-button-accept". We hide the card and the
         body-level wrapper that contains it — hiding the wrapper also removes the
         backdrop of the centered/modal banner type. The "--"-prefixed class is
         awkward to write as a ".--..." selector, so we match it with
         [class~="..."]. */
      [class~="--framer-cookie-banner-container"] { display: none !important; }
      html body > div:has([class~="--framer-cookie-banner-container"]) {
        display: none !important;
      }
  `,
};
